import React from "react";

import { useRecoilValueLoadable, useSetRecoilState } from "recoil";
import {
  alarmRefresh,
  asyncAlarmState,
  errorToastState,
  updateUserAlarmRead,
  readOneUserAlarm,
} from "lib/store/common";

import { Alarm } from "components/atom/Alarm";

export const UserAlarm: React.FC = () => {
  const setRefreshAlarm = useSetRecoilState(alarmRefresh);
  const setError = useSetRecoilState(errorToastState);
  const alarm = useRecoilValueLoadable(asyncAlarmState);
  return (
    <Alarm
      data={alarm}
      handleClickRead={async (id) => {
        try {
          await readOneUserAlarm(id);
        } catch (e) {
          setError(e);
        }
        await setRefreshAlarm(new Date());
      }}
      handleClickAllRead={async () => {
        if (alarm.state !== "hasValue") return;
        try {
          await updateUserAlarmRead({ id: alarm.contents.map((i) => i.id) });
        } catch (e) {
          setError(e);
        }
        await setRefreshAlarm(new Date());
      }}
    />
  );
};
